import { TreeDirectiveModule } from '@b2b/common/directives/tree/tree.directive';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { SelectionTreeNode, TreeNodeCtrl } from '@b2b/common/utils/tree-node';
import { ContentHeaderProps, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IPromise, IScope, ITimeoutService } from 'angular';
import { PricingCheckboxModule } from '../../components/pricing-checkbox/pricing-checkbox.component';

MembershipPricingDiscountsCreateController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  'ApiService',
  'HelpersService',
  'PermissionsService',
  'NoticeFactory',
];

function MembershipPricingDiscountsCreateController(
  $scope: IScope & { membershipPricingDiscountsCreate: TODO },
  $state: StateService,
  $uibModal: UIBModalService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  HelpersService: TODO,
  PermissionsService: PermissionsService,
  NoticeFactory: NoticeFactory,
) {
  const ctrl = {
    isLoaded: false,
    model: {} as TODO,
    membershipLevels: [] as TODO[],
    couponCategories: [] as TODO[],
    discounts: [] as TODO[],
    existingDiscounts: [] as TODO[],
    mode: 'create',
    noticeTimer: null as IPromise<void> | null,
    notice: new NoticeFactory(),
    tree: new SelectionTreeNode(),

    init: function () {
      if ($state.params.id) {
        ctrl.mode = 'edit';
      }

      $scope.$emit('Application::contentTitleChange', {
        title: ctrl.isMode('edit') ? 'Edit Membership Coupon Discount' : 'New Membership Coupon Discount',
        buttonRight: {
          permissions: ctrl.isMode('edit')
            ? ['MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_UPDATE']
            : ['MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_CREATE'],
          label: ctrl.isMode('edit') ? 'Save' : 'Create',
          action: () => {
            ctrl.save();
          },
        },
        buttonLeft: {
          label: 'Close',
          action: () => {
            ctrl.close();
          },
        },
      } as ContentHeaderProps);

      ctrl.getCouponDiscounts();
    },

    getCouponDiscounts: function () {
      const props = HelpersService.getPaginator();

      if ($state.params.action) {
        props.lifecycleActions = [$state.params.action];
      }

      ApiService.membership.lifecycle.discounts
        .list(props)
        .then((response) => ctrl.success.init(response))
        .catch((response) => ctrl.error.init(response));
    },

    getDiscounts: function () {
      return ApiService.discounts
        .list('v2', HelpersService.getPaginator())
        .then((response) => ctrl.success.getDiscounts(response))
        .catch((response) => ctrl.error.getDiscounts(response));
    },

    getCouponCategories: function () {
      return ApiService.coupons.categories
        .list(HelpersService.getPaginator())
        .then((response) => ctrl.success.getCouponCategories(response))
        .catch(() => {
          // noop
        });
    },

    getMembershipLevels: function (group?: TODO) {
      const props = HelpersService.getPaginator();

      props.salesChannels = 'online,insideSalesIndividual,pointOfSale,reseller,manualEntry,customerRep';
      props.isPublished = '1';
      props.summarize = '1';

      if (group) {
        props.membershipLevelGroup = group;
      }

      ApiService.membership.categories
        .list(props)
        .then((response) => ctrl.success.getMembershipLevels(response))
        .catch((response) => ctrl.error.getMembershipLevels(response));
    },

    isMode: function (mode) {
      return ctrl.mode === mode;
    },

    findItem: function (itemId, list) {
      let r: { item: TODO; index: number } | false = false;

      list = list || [];

      for (let i = 0, ii = list.length; i < ii; i++) {
        if (itemId === list[i].id) {
          r = {
            item: list[i],
            index: i,
          };
          break;
        }
      }

      return r;
    },

    process: function () {
      for (let i = 0, ii = ctrl.existingDiscounts.length; i < ii; i++) {
        if (ctrl.isMode('edit') && $state.params.id && $state.params.id === ctrl.existingDiscounts[i].id) {
          ctrl.model = ctrl.existingDiscounts[i];
          break;
        }
      }
    },

    processCouponCategories: function () {
      let found: TODO = false;

      for (let i = 0, ii = ctrl.existingDiscounts.length; i < ii; i++) {
        if (ctrl.existingDiscounts[i].hasOwnProperty('couponCategory') && ctrl.existingDiscounts[i].couponCategory.id) {
          found = ctrl.findItem(ctrl.existingDiscounts[i].couponCategory.id, ctrl.couponCategories);
          if (found) {
            if (ctrl.isMode('edit')) {
              if (
                ctrl.model.couponCategory &&
                ctrl.model.couponCategory.id &&
                found.item.id !== ctrl.model.couponCategory.id
              ) {
                ctrl.couponCategories.splice(found.index, 1);
              } else {
                ctrl.model.couponCategory = found.item;
              }
            } else {
              ctrl.couponCategories.splice(found.index, 1);
            }
          }
        }
      }
    },

    processDiscounts: function () {
      if (ctrl.isMode('edit') && ctrl.model.discount && ctrl.model.discount.id) {
        const found = ctrl.findItem(ctrl.model.discount.id, ctrl.discounts);

        if (found) {
          ctrl.model.discount = found.item;
        }
      }
    },

    toggleTree: function () {
      ctrl.tree.toggleTree();
    },

    toggleNode: function (
      $ctrl: TreeNodeCtrl<{ selected: boolean; partial: boolean }>,
      nodeModel: { selected: boolean; partial: boolean },
    ) {
      ctrl.tree.toggleNode($ctrl, nodeModel);
    },

    selectMemberships: function () {
      for (let i = 0, ii = ctrl.model.membershipLevelInfo.length; i < ii; i++) {
        const membershipDiscountLevel = ctrl.model.membershipLevelInfo[i];

        if (
          Array.isArray(membershipDiscountLevel.membershipOfferings) &&
          membershipDiscountLevel.membershipOfferings.length
        ) {
          const found = ctrl.findItem(membershipDiscountLevel.membershipLevel.id, ctrl.membershipLevels);

          if (found && Array.isArray(found.item.offerings) && found.item.offerings.length) {
            for (let j = 0, jj = membershipDiscountLevel.membershipOfferings.length; j < jj; j++) {
              const foundOffering = ctrl.findItem(
                membershipDiscountLevel.membershipOfferings[j].id,
                found.item.offerings,
              );

              if (foundOffering) {
                foundOffering.item.selected = true;
              }
            }
            ctrl.updateMembershipLevelSelection(found.item);
          }
        }
      }
    },

    updateMembershipLevelSelection: function (level) {
      let selected = [];

      level.partial = false;
      level.selected = false;

      if (level && Array.isArray(level.offerings)) {
        selected = level.offerings.filter((offering) => {
          return offering.selected;
        });

        if (selected.length) {
          if (selected.length < level.offerings.length) {
            level.partial = true;
          } else if (selected.length === level.offerings.length) {
            level.selected = true;
            level.partial = false;
          }
        }
      }
    },

    marshal: function () {
      const memberships: TODO[] = [];

      for (let i = 0, ii = ctrl.membershipLevels.length; i < ii; i++) {
        if (ctrl.membershipLevels[i].selected || ctrl.membershipLevels[i].partial) {
          const offerings: { id: number; name: string }[] = [];

          for (let j = 0, jj = ctrl.membershipLevels[i].offerings.length; j < jj; j++) {
            if (ctrl.membershipLevels[i].offerings[j].selected) {
              offerings.push({
                id: ctrl.membershipLevels[i].offerings[j].id,
                name: ctrl.membershipLevels[i].offerings[j].name,
              });
            }
          }

          if (offerings.length) {
            memberships.push({
              membershipLevel: {
                id: ctrl.membershipLevels[i].id,
                name: ctrl.membershipLevels[i].name,
              },
              membershipOfferings: offerings,
              supportAllOfferings: false,
            });
          }
        }
      }

      return memberships;
    },

    save: function () {
      ctrl.notice.hideErrorMessages();

      if (!ctrl.model.couponCategory) {
        ctrl.notice.showErrorMessages([{ message: 'Please choose a coupon category.' }]);
        return;
      }
      if (!ctrl.model.discount) {
        ctrl.notice.showErrorMessages([{ message: 'Please choose a discount.' }]);
        return;
      }

      const data = ctrl.marshal();

      if (!data.length) {
        ctrl.notice.showErrorMessages([{ message: 'Please choose at least one membership offering' }]);
        return;
      }

      if (ctrl.isMode('edit')) {
        ApiService.membership.lifecycle.discounts
          .update({
            id: ctrl.model.id,
            membershipLevelInfo: data,
            couponCategory: ctrl.model.couponCategory,
            discount: ctrl.model.discount,
            lifecycleAction: $state.params.action,
          })
          .then((response) => ctrl.success.save(response))
          .catch((response) => ctrl.error.save(response));
      } else {
        ApiService.membership.lifecycle.discounts
          .create({
            membershipLevelInfo: data,
            couponCategory: ctrl.model.couponCategory,
            discount: ctrl.model.discount,
            lifecycleAction: $state.params.action,
          })
          .then((response) => ctrl.success.save(response))
          .catch((response) => ctrl.error.save(response));
      }
    },

    close: function () {
      $state.go('application.membership.pricing.discounts');
    },

    showCoupons: function (couponCategoryId: TODO) {
      $uibModal
        .open({
          templateUrl: 'views/application/views/templates/modals/showCouponsModal.tpl.html',
          size: 'md',
          controller: 'TemplatesShowCouponsModalController',
          resolve: {
            CouponCategoryListData: () => {
              return ApiService.coupons.getCouponsByCategory(couponCategoryId, HelpersService.getPaginator());
            },
          },
        })
        .result.catch(() => {
          // noop
        });
    },

    success: {
      init: function (response) {
        ctrl.existingDiscounts = response.data.payload.list;
        ctrl.process();
        ctrl.isLoaded = true;
        ctrl.getDiscounts();
        ctrl.getCouponCategories();
        ctrl.getMembershipLevels();
      },
      getDiscounts: function (response) {
        ctrl.discounts = response.data.payload.list;
        ctrl.processDiscounts();
      },
      getCouponCategories: function (response) {
        ctrl.couponCategories = response.data.payload.list;
        ctrl.processCouponCategories();
      },
      getMembershipLevels: function (response) {
        ctrl.membershipLevels = response.data.payload.list;
        if (ctrl.isMode('edit')) {
          ctrl.selectMemberships();
        }

        $timeout(() => {
          // We have to wait until the next tick because TreeNodes haven't been created on the DOM yet
          ctrl.tree.updateTree();
        }, 0);
      },
      save: function (response) {
        if (ctrl.isMode('edit')) {
          if (ctrl.noticeTimer) {
            $timeout.cancel(ctrl.noticeTimer);
          }

          ctrl.notice.showSuccessMessages([{ message: 'Successfully Saved!' }]);
          ctrl.noticeTimer = $timeout(() => {
            ctrl.notice.hideSuccessMessages();
          }, 3000);
        } else {
          if (PermissionsService.check('MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_UPDATE')) {
            $state.go('application.membership.pricing.discounts.edit', { id: response.data.payload.id });
          } else {
            ctrl.close();
          }
        }
      },
    },

    error: {
      init: function (response) {
        ctrl.getDiscounts();
        ctrl.getCouponCategories();
        ctrl.getMembershipLevels();
      },
      getDiscounts: function (response) {},
      getMembershipLevels: function (response) {},
      removeMembershipCouponDiscount: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },
      save: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },
    },

    onLevelChange: function (level) {
      $timeout(() => {
        if (!Array.isArray(level.offerings)) {
          return;
        }

        const selected = level.selected || level.partial;
        level.offerings.forEach((offering) => {
          offering.selected = selected;
        });
      }, 0);
    },

    onOfferingChange: function (offering, level) {
      $timeout(() => {
        ctrl.updateMembershipLevelSelection(level);
      }, 0);
    },
  };

  $scope.membershipPricingDiscountsCreate = ctrl;
  ctrl.init();
}

export const MembershipPricingDiscountsCreateControllerModule = angular
  .module('acme.view.application.membership.pricing.discounts.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.factory.notice',
    'acme.common.service.permissions',
    TreeDirectiveModule,
    PricingCheckboxModule,
  ])
  .controller('MembershipPricingDiscountsCreateController', MembershipPricingDiscountsCreateController).name;
